export const SCROLL_OFFSET = 10;
